import { render, staticRenderFns } from "./CreateChecklistConfig.vue?vue&type=template&id=139d0ce7&scoped=true"
import script from "./CreateChecklistConfig.vue?vue&type=script&lang=js"
export * from "./CreateChecklistConfig.vue?vue&type=script&lang=js"
import style0 from "./CreateChecklistConfig.vue?vue&type=style&index=0&id=139d0ce7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d0ce7",
  null
  
)

export default component.exports